<template>

 <v-radio-group :rules="item.rules || []" :class="item.class || ''" :hint="item.hint"  v-model="item.value" column>
    <p class="vrg-title">{{ item.label }}</p>
      <v-radio 
        v-for="(option, i) in item.options"
         mandatory
        :key="option.value + i"
        :label="option.label"
        :input-value="option.value"
        :value="option.value"
        v-show="option.visible !== undefined ? option.visible : true"
        :disabled="option.disabled || false"
        :title="option.value"
      ></v-radio>

      <div
      v-for="(option, i) in item.options" :key="i"
      v-show="option.hint && item.value === option.value"
      class="input-group__details"
      >
        <div class="input-group__messages input-group__error">
          {{option.hint}}
        </div>
      </div>
    </v-radio-group>

</template>

<script>

'use strict'

export default {

  name: 'VuetifyRadioGroup',

  props: {
    item: {
      type: Object,
      default: null,
      required: true
    }
  },

  watch: {
    'item.value': function (newVal, oldVal) {
      this.$emit('on-change', newVal, oldVal, this.item, true)
    }
  },

  methods: {
    focusNextField: function (event) {
      if (this.item.focusNextOnEnter) {
        event.target.form[this.item.index + 1].focus()
      }
    }
  }
}
</script>

<style lang="sass">
.vrg-title
  color: rgba(0, 0, 0, 0.54)
  display: inline-block
  font-size: 16px
  line-height: 30px
  height: 30px
  text-align: left
  text-overflow: ellipsis
  z-index: 0

.radio-group
  margin-top: -47px

.input-group__messages
  text-align: left
</style>


// WEBPACK FOOTER //
// src/components/vuetify-form-creator/fields/vuetify-radio-group.vue